module.exports = __webpack_public_path__ + "static/media/calendarIcon.svg";